import React, { useEffect,useState } from "react";
import { Button, Empty,Pagination,Select } from "antd";

import useStatsStore from "../../store/stats.store";
import useMembersStore from "../../store/members.store";

import Table from "../Table";
import "./sourcing.scss";
import useSourcingStore from "../../store/sourcing.store";
import FilterSourcing from "../filterSourcing";

export default function Sourcing(props) {


  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
   const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const { sourcingDetails,getSourcingDetails,sourcingDetailsJd,sourcingDetailsTotalCount } = useSourcingStore();

  useEffect(() => {
  }, []);

  const titleList = [
    "Sr. No.",
    "Client",  
    "TA",
    "Resume ID",    
    "JD Title",    
    "Name", 
    "Suitability",
    "Candidate Status",
    "Extra Analysis",
    "Resume Status",
    "Interview Status",
    "BGV Status",
    "Offer Status",     
    "Ownership", 
    "Sourced By",
    "Sourced On",
    "Last Updated On",
    "Last Updated By",
    "Missing Skills",
    "Final Score",    
  ];
  const getJD =(jdID) =>{
    const jd = sourcingDetailsJd.filter((item)=> item?.qhcompanyjid===jdID)
    return jd[0]
  }
  function formatUnixDate(ts) {
      const d = new Date(ts * 1000);
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      const yyyy = d.getFullYear();

      return `${dd}-${mm}-${yyyy}`;
    }  
  
  const mapResumeQuality =(qual) =>{
    if(qual >=60){
      return "Good Match"
    }else if (qual >=50 && qual<60){
      return "Above Average"
    }else if ((qual >=40) && (qual<50)){
      return "Average"
    }else if ((qual >=30) && (qual<40)){
      return "Below Average"
    }else if (qual<30){
      return "Not Suitable"
    }else{
      return "Unknown"
    }
  }

  const extraAnalysisData = (extraanalysis) =>{
      let str = "Suitable";
      if(extraanalysis?.ishighctc ){
        str = "HCTC"
      }
      if (extraanalysis?.ishighnp){
        if(str == "HCTC") {
          str = str + " / "         
          str = str + "HNP"
        }else{
          str = "HNP"
        }
      }
      return str
  }

  const sDetailData = sourcingDetails?.map((item, idx) => {
    const scorelist = item?.resumescore?.scorelist || {};
    const keywordsObj = scorelist?.skill_scores?.keywords || {};
    const keywordString = Object.entries(keywordsObj)
          .filter(([_, value]) => (value.avg ?? 0) <30 )
          .map(([key]) => key)
          .join(", ");
    const jd = getJD (item.qhcompanyjid)
    return {
      id: (idx + 1)+ (currentPage-1)*pageSize, 
      client_name: jd?.jdclient?.clientname,
      ta_name: jd.jdclient?.taname,
      resumeID:item.qhrid,      
      title: '['+jd.qhcompanyjid+'] '+jd.jddetails?.title,
      name: item.applicationid.name,
      resumeSuitability: mapResumeQuality(item?.resumescore?.score),
      candidateStatus: item?.candidatestatus.status,
      extra:extraAnalysisData(item?.extraanalysis), 
      resumeStatus: item?.resumestatus.status,
      interviewStatus: item?.interviewstatus.status,
      bgvStatus: item?.bgvstatus.status,
      offerStatus: item?.selectionstatus.status,       
      ownership: "By Team",
      recruiterName: item?.sourcingdetails?.teamdetails?.name,
      uploadedon: formatUnixDate(item?.sourcingdetails.teamdetails.timestamp),
      lastUpdateOn: formatUnixDate(item?.timestamp),
      uploadedby: item?.updatedby,
      matchingskills: keywordString,
      finalScore:item?.resumescore?.score + " % ",           
    };
  });

  return (
    <div className="sourcing-wrapper">
      <div>
      <FilterSourcing
        filtername = {"getSourcingDetails"}
        initRange={"24"}
        initPrio={"All"}
        initJDStatus={"Active"} 
        pageNo = {currentPage}
        pageSize = {pageSize}        
        enableTeamMember  
        enableTAs 
        enableRange
        enablePriority
        enableJdStatus
        enableCustomers
        enableResumeQuality 
        enableCandidateStatus 
        enableInterviewStatus   
        enableResumeStatus
        handleFilter={getSourcingDetails}
        setCurrentPage={setCurrentPage}
      />
      <div></div>
      </div>
      <div className="sourcing-title">
       ({sourcingDetailsTotalCount || 0}){" "} Sourcing Results Found 
      </div>
      <div>
        {sDetailData?.length > 0 ? (
          <Table
            isClickable={true}
            isJDPage={true}
            titleList={titleList}
            data={sDetailData}
            columnWidth={[
              50, 100, 100, 100, 200, 200, 200, 200,100, 200, 200, 200, 200, 200,
              200, 100, 100, 200,200,100
            ]}
          />
        ) : (
          <Empty style={{ margin: "60px" }} />
        )}        
      </div>
       <Pagination
              style={{ margin: "20px",  float: "inline-end" }}
              current={currentPage}
              pageSize={pageSize}
              total={sourcingDetailsTotalCount}
              onChange={(page, pageSize) => {
                handlePageChange(page, pageSize);
                
              }}
              showSizeChanger
              pageSizeOptions={[10, 20, 50, 100, 150]}
            />      

    </div>
  );
}
